export const isEnterprise = (networkId: string) => {
  // TODO: Remove this once we have a CMP provider is being used (for disabling clarity and snowplow)
  // aT1Vn6PT6O: Mercedes
  return ['aT1Vn6PT6O'].includes(networkId)
}
